import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { apiDocsConfigApi } from './apis';

export const apiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [apiDocsConfigApi],
});
